"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var view_1 = (0, tslib_1.__importDefault)(require("../core/view"));
var templates_1 = require("./templates");
var htmlToElement_1 = (0, tslib_1.__importDefault)(require("../core/htmlToElement"));
var loader_scss_1 = (0, tslib_1.__importDefault)(require("./loader.scss"));
var LoaderView = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(LoaderView, _super);
    function LoaderView() {
        var _this = _super.call(this) || this;
        _this._$rootElement = (0, htmlToElement_1.default)((0, templates_1.loaderTemplate)({
            styles: _this.styleNames,
        }));
        return _this;
    }
    LoaderView.prototype.getElement = function () {
        return this._$rootElement;
    };
    LoaderView.prototype.showContent = function () {
        this._$rootElement.classList.add(this.styleNames.active);
    };
    LoaderView.prototype.hideContent = function () {
        this._$rootElement.classList.remove(this.styleNames.active);
    };
    LoaderView.prototype.hide = function () {
        this._$rootElement.classList.add(this.styleNames.hidden);
    };
    LoaderView.prototype.show = function () {
        this._$rootElement.classList.remove(this.styleNames.hidden);
    };
    LoaderView.prototype.destroy = function () {
        if (this._$rootElement.parentNode) {
            this._$rootElement.parentNode.removeChild(this._$rootElement);
        }
        this._$rootElement = null;
    };
    return LoaderView;
}(view_1.default));
LoaderView.extendStyleNames(loader_scss_1.default);
exports.default = LoaderView;
//# sourceMappingURL=loader.view.js.map